import "./welcome.css"
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import Alert from "react-bootstrap/Alert";
import {Camera} from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import capture from "../../../assets/photo_capture.jpeg"
import {Spinner} from "react-bootstrap";
import apiClient from "../../../utils/axios";

function UploadButtons({appData}) {

    const {t} = useTranslation()

    const [showAlert, setShowAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successAlert, setSuccessAlert] = useState(false);
    const fileInputRef = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        window.gtag('config', 'AW-937928979');

        window.gtag('event', 'conversion', {
            'send_to': 'AW-937928979/5PP9CKnCk2QQk9KevwM',
        });
    }, []);

    useEffect(() => {
        function disableBack() {
            window.history.pushState(null, null, window.location.href);
            window.onpopstate = function () {
                window.history.pushState(null, null, window.location.href);
            };
        }

        disableBack();

        return () => {
            window.history.forward();
        };
    }, []);

    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    useEffect(() => {
        if (errorMessage) {
            const timer = setTimeout(() => {
                setErrorMessage(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [errorMessage]);

    useEffect(() => {
        if (successAlert) {
            const timer = setTimeout(() => {
                setSuccessAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [successAlert]);

    const handleUpload = async (selectedFile, type = null) => {
        let selectedFiles;
        if (type) {
            selectedFiles = [selectedFile];
        } else {
            selectedFiles = fileInputRef.current.files;
        }

        if (!selectedFiles) {
            return;
        }

        for (const selectedFile of selectedFiles) {
            if (selectedFile.size > 6 * 1024 * 1024) {
                setShowAlert(true);

                setTimeout(() => {
                    setErrorMessage('');
                    setShowAlert(false);
                }, 3000);

                return;
            }

            const allowedTypes = ["pdf", "x-pdf", "jpeg", "gif", "png", "jpg"];
            const fileType = selectedFile.type.split("/")[1];
            if (!allowedTypes.includes(fileType)) {
                setErrorMessage("File type not allowed. Allowed types: pdf, jpeg, gif, png, jpg");
                setShowAlert(true);
                return;
            }

            const formData = new FormData();
            formData.append("file", selectedFile);

            try {
                const response = await apiClient.post(
                    `${process.env.REACT_APP_API_URL}/api/accounts/upload/${appData.app_id}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (response.data.status === '403') {
                    setShowAlert(true);
                } else {
                    setSelectedFiles(prevFiles => [...prevFiles, selectedFile.name]);
                    if (response.data.message) {
                        setErrorMessage(response.data.message);
                        setSuccessAlert(false);
                    } else {
                        setErrorMessage('');
                        setSuccessAlert(true);
                        trackConversion();
                    }
                }

                if (response.data && response.data.status &&
                    ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                    throw new Error(response.data.message || 'Unknown error occurred');
                }
            } catch (error) {
                throw error;
            }
        }

        fileInputRef.current.value = null;
    };

    const onTakePhoto = (dataUri) => {
        setPreviewImage(dataUri);
        setIsPreviewOpen(true);
        setIsPopupOpen(false);
    };

    const handleContinue = async () => {
        setIsLoading(true);
        try {
            const base64Image = previewImage.split(",")[1];
            const blob = base64toBlob(base64Image, "image/png");
            const fileName = "identification.png";
            const selectedFile = new File([blob], fileName, {type: "image/png"});

            await handleUpload(selectedFile, "camera");
            setPreviewImage(null);
            setIsPreviewOpen(false);
        } catch (error) {
            console.error("Error uploading photo:", error);
            setErrorMessage("Error uploading photo. Please try again.");
            setShowAlert(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRetake = () => {
        setPreviewImage(null);
        setIsPreviewOpen(false);
        setIsPopupOpen(true);
    };

    const base64toBlob = (base64Data, contentType) => {
        const sliceSize = 1024;
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: contentType});
    };

    const openPopup = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    const closePreviewPopup = () => {
        setIsPreviewOpen(false);
    };

    const trackConversion = () => {
        var _promocode = ''; /* promocode, if any */
        function _enc(s) {
            if (typeof encodeURIComponent == 'function') {
                return encodeURIComponent(s);
            } else {
                return escape(s);
            }
        }

        var _referer = document.referrer;
        var i = new Image(1, 1);
        i.src = 'https://directtrack.choicetrade.com/redirect/img.php?promocode=' + _enc(_promocode) + '&referer=' + _enc(_referer) + '&type=sale';

        i.onload = function () {
            return;
        }
    };

    const isMobile = () => {
        return /Mobi|Android/i.test(navigator.userAgent);
    };

    return (
        <div className="w-full mt-3">
            <div className="upload_capture_btns flex gap-3 mb-3 flex-wrap ">
                <label
                    className="upload_btn w-auto border-0 text-white text-center cursor-pointer font-normal text-3xl px-4 py-2">
                    <input
                        type="file"
                        className="hidden"
                        onChange={handleUpload}
                        ref={fileInputRef}
                        multiple
                    />
                    <span>{t("welcome_to.upload")}</span>
                </label>

                <button
                    className="take_photo_btn w-auto border-0 px-3 py-2 text-white text-center cursor-pointer font-normal text-3xl"
                    onClick={openPopup}>
                    {t("welcome_to.capture_image")}
                </button>
            </div>

            {isPopupOpen && (
                <div
                    className="popup fixed top-0 left-0 w-full h-full flex justify-content-center align-items-center z-5">
                    <div className="popup-content bg-white p-3 relative">
                        <span className="close absolute cursor-pointer" onClick={closePopup}>&times;</span>
                        <div
                            className="flex sm:flex-row flex-column sm:align-items-end align-items-center justify-content-center pb-2">
                            <img width="120" height="120" src={capture} alt=""/>
                            <div className="capture_text text-center">
                                <h3>{t("welcome_to.picture_id")}</h3>
                                <p className="mb-3">{t("welcome_to.confirm_doc")}</p>
                            </div>
                        </div>

                        <Camera
                            onTakePhoto={(dataUri) => {
                                onTakePhoto(dataUri);
                            }}
                            isFullscreen={false}
                            idealFacingMode={isMobile() ? "environment" : "user"}
                        />
                    </div>
                </div>
            )}

            {isPreviewOpen && (
                <div
                    className="preview-popup fixed top-0 left-0 w-full h-full flex justify-content-center align-items-center z-5">
                    <div className="preview-content bg-white p-3 relative text-center">
                        <div className="flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">{t("welcome_to.photo_text")}</h5>
                            <span className="close absolute cursor-pointer"
                                  onClick={closePreviewPopup}>
                                &times;
                            </span>
                        </div>
                        <img src={previewImage} alt="Captured"
                             className="preview-image w-full h-auto max-w-25rem mb-3"/>
                        <div className="flex justify-content-around flex-wrap gap-2">
                            <button
                                onClick={handleContinue}
                                className="preview-button border-0 border-round-sm cursor-pointer text-white font-base px-2 py-3"
                                disabled={isLoading}
                            >
                                {isLoading ? <Spinner animation="border" size="sm"/> : t("next_btn")}
                            </button>
                            <button onClick={handleRetake}
                                    className="preview-button border-0 border-round-sm cursor-pointer text-white font-base px-2 py-3">
                                {t("welcome_to.retake_photo")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="selected-files">
                {selectedFiles.length > 0 && (
                    <>
                        <ul className="pl-0" style={{width: "fit-content"}}>
                            {selectedFiles.map((file, index) => (
                                <li key={index} className="file_list w-max list-none text-white mt-3 mb-5 ml-5">{file}</li>
                            ))}
                        </ul>
                    </>
                )}
            </div>

            <div className="alert_message w-4">
                {showAlert && (
                    <Alert variant="danger">
                        Only allowed pdf, x-pdf, jpeg, gif, png, jpg files with a size under 6MB.
                    </Alert>
                )}

                {errorMessage && (
                    <Alert variant="danger">
                        {errorMessage}
                    </Alert>
                )}

                {successAlert && !errorMessage && !showAlert && (
                    <Alert variant="success">
                        File uploaded successfully
                    </Alert>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    appData: state.appData
});

export default connect(mapStateToProps)(UploadButtons);